import instIcon from '../images/instIcon.svg';
import location from '../images/locationIcon.svg';
import phone from '../images/IconPhone.svg';
import email from '../images/emailIcon.svg'

 const ContactData = [
  {
  title: 'instagram',
  name: '@vosmoe_nebo_',
  icon: instIcon
  },
  {
    title: 'Адрес',
    name: 'г. Михайловск, Российский заезд, 63/1',
    icon: location
  },
  {
    title: 'Летняя территория',
    name: '601-760',
    icon: phone
  },
  {
    title: 'e-mail',
    name: 'vosmoe_nebo@gmail.com',
    icon: email
  },
  {
    name: '*Информация размещенная  на сайте не является публичной офертой',
  },
  {
    name: '*Сайт в стадии разработки, уточняйте информацию у администратора',
  },
]

export default ContactData